import { render, staticRenderFns } from "./manage-audio.vue?vue&type=template&id=4c686fd8&scoped=true&"
import script from "./manage-audio.vue?vue&type=script&lang=js&"
export * from "./manage-audio.vue?vue&type=script&lang=js&"
import style0 from "./manage-audio.vue?vue&type=style&index=0&id=4c686fd8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c686fd8",
  null
  
)

export default component.exports